exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".download_button{\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n}\n.heatmap{\n    display: flex;\n    padding-top:3%;\n    height:20vw;\n    width:100%;\n    \n  }\n\n.grid{\nwidth:100%;\nheight:15vw;\n}", ""]);

// exports
